export default "https://fiverr-res.cloudinary.com/npm-assets/@fiverr/search_perseus/apps/postgres.1f53e47.svg";